<div class="card mt-4">
    <div class="card-body">
        <div class="top-cantainer pr-4 relative">
            <app-subtitle-hr [title]="title" />
            <i class="pi pi-angle-down button-float" [ngClass]="{'rotate-button': rotate}" (click)="hide()"></i>
        </div>
        <div class="hide-container" [ngClass]="{'show-container': show}">
            <div>
                <ng-container *ngTemplateOutlet="body"></ng-container>
            </div>
        </div>
    </div>
</div>